import {OrderGQLDtoSummary} from "../../features/order/order-api";
import {t} from "i18next";

export function getOrderSummaryTotalWeight(
  orderSummary: OrderGQLDtoSummary | null | undefined,
): string | null {
  if (!orderSummary) {
    return null;
  }
  const {totalWeight, weightUnit} = orderSummary;
  if (!totalWeight || !weightUnit) {
    return null;
  }
  return `${totalWeight} ${t(weightUnit.toLowerCase())?.toLowerCase()}`;
}
